module.exports = __webpack_public_path__ + "static/media/employee-appreciation-hero.36ddc311.jpg";